import styled from "styled-components"

const padding = "6px 12px"
const marginBottom = "8px"

export const FormGroup = styled.div<{
    inline?: boolean
}>`
    display: flex;
    flex-direction: ${(props) => (props.inline ? "row" : "column")};
    align-items: ${(props) => (props.inline ? "center" : "inherit")};
    width: 100%;
    margin-bottom: 5px;

    & > * {
        margin-right: ${(props) => (props.inline ? "10px !important" : "inherit")}
    }

    & > *:last-child {
        margin-right: ${(props) => (props.inline ? "0px !important" : "inherit")}
    }
`
export const Label = styled.label<{
    row?: boolean
    flex?: boolean
}>`
    display: ${(props) => (props.flex ? "flex" : "block")};
    margin-bottom: ${(props) => (props.row ? "0" : "3px")};
    margin-right: ${(props) => (props.row ? "10px" : "0")};
    text-transform: uppercase;
    font-weight: 600;
    font-size: ${(props) => props.theme.fontSizes.xs}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.labelColor};
`
export const LabelButton = styled.span`
    float: right;
    text-transform: capitalize;
    line-height: 16px;
    font-weight: 500;
    font-size: ${(props) => props.theme.fontSizes.sm}px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.labelButtonColor};
    border-bottom: 1px dashed transparent;

    &:hover {
        color: ${(props) => props.theme.labelButtonHoverColor};
        border-color: ${(props) => props.theme.labelButtonHoverBorderColor};
    }
`
export const LabelValue = styled.span`
    text-transform: lowercase;
    font-size: 13px;
    color: grey;
`
export const Input = styled.input<{
    row?: boolean
    noMargin?: boolean
}>`
    border: none;
    outline: none;
    padding: ${padding};
    margin-bottom: ${(props) => {
        if (props.noMargin) return "0"
        if (props.row) return "0"
        return marginBottom
    }};
    margin-right: ${(props) => {
        if (props.row) return "10px"
        return 0
    }};
    color: ${(props) => props.theme.inputColor};
    background: ${(props) => props.theme.inputBackground};

    &:focus {
        color: ${(props) => props.theme.inputFocusColor};
    }

    &::placeholder {
       color: ${(props) => props.theme.inputPlaceholder};
    }

    &[type=time] {
        &::-webkit-calendar-picker-indicator {
            filter: invert(1) brightness(0.5);
        }
    }
`
export const DivInput = styled.div<{
    widePadding?: boolean
    row?: boolean
}>`
    padding: ${(props) => (props.widePadding ? padding : "2px 12px")};
    margin-bottom: ${(props) => (props.row ? "0" : marginBottom)};
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    color: ${(props) => props.theme.inputColor};
    background: ${(props) => props.theme.inputBackground};

    &:focus {
        color: ${(props) => props.theme.inputFocusColor};
    }
`
export const Textarea = styled.textarea`
    border: none;
    outline: none;
    padding: ${padding};
    margin-bottom: ${marginBottom};
    color: ${(props) => props.theme.inputColor};
    background: ${(props) => props.theme.inputBackground};

    &:focus {
        color: ${(props) => props.theme.inputFocusColor};
    }
`
export const CheckboxWrapper = styled.div<{
    displayColumn?: boolean
}>`
    display: flex;
    flex-direction: ${(props) => (props.displayColumn ? "column" : "row")};
    padding: 8px 8px 5px 8px; // to neutralize bottom margins
    margin-bottom: ${marginBottom};
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    background: ${(props) => props.theme.inputBackground};
`
